module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-message-wrapper",
    style: ({
      'left': _vm.calculatePosition(_vm.position)
    })
  }, [(_vm.showParticipantsList && _vm.isGroupMessage) ? _c('div', {
    staticClass: "participants"
  }, [_c('ul', _vm._l((_vm.participants), function(participant) {
    return _c('li', [_vm._v("\n                " + _vm._s(participant.name) + "\n                "), _c('img', {
      staticClass: "role-icon",
      attrs: {
        "src": _vm._f("roleIcon")(participant.roles)
      }
    })])
  }))]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove close-chat",
    on: {
      "click": function($event) {
        _vm.closeChat()
      }
    }
  }), _vm._v(" "), (_vm.minimized) ? _c('i', {
    staticClass: "fa fa-window-maximize",
    on: {
      "click": function($event) {
        _vm.minimized = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.minimized) ? _c('i', {
    staticClass: "fa fa-window-minimize",
    on: {
      "click": function($event) {
        _vm.minimized = true
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "text-center"
  }, [(_vm.isGroupMessage) ? _c('span', {
    staticClass: "badge",
    on: {
      "click": function($event) {
        _vm.showParticipantsList = !_vm.showParticipantsList
      }
    }
  }, [_vm._v(_vm._s(_vm.participants.length))]) : _vm._e(), _vm._v(_vm._s(_vm.chatName))]), _vm._v(_vm._s(_vm.groupId) + "              \n        "), _c('VuePerfectScrollbar', {
    staticClass: "scroll-area"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.minimized),
      expression: "!minimized"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.getMore),
      expression: "getMore"
    }],
    staticClass: "chat-messages",
    attrs: {
      "id": "chat-messages",
      "infinite-scroll-immediate-check": "true",
      "infinite-scroll-disabled": "busy",
      "infinite-scroll-throttle-delay": "250",
      "infinite-scroll-distance": "300"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.busy == true),
      expression: "busy==true"
    }],
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "white loading-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "blue loading-image"
  })]), _vm._v(" "), _vm._l((_vm.messages), function(message) {
    return _c('div', {
      staticClass: "message"
    }, [_c('div', {
      staticClass: "bubble",
      class: {
        'mine': message.from == _vm.localStorage.user_id || message.userId == _vm.localStorage.user_id
      }
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.linkify(message.body))
      }
    }), _vm._v(" "), (_vm.isGroupMessage && _vm.localStorage.user_id != message.userId) ? _c('span', {
      staticClass: "author"
    }, [_vm._v(_vm._s(message.name))]) : _vm._e()])])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.minimized),
      expression: "!minimized"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    ref: "messageText",
    staticClass: "message-text"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    ref: "messageInput",
    staticClass: "message-input form-control",
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendMessage()
      }
    }
  }, [_vm._v("Send")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-19447764!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/ChatMessages.vue
// module id = 1984
// module chunks = 2